const ENGLISH_US = "en-US";
const FRENCH_FRANCE = "fr-FR";
const SPANISH_SPAIN = "es-ES";
const GERMAN_GERMANY = "de-DE";
const BRAZILIAN_PORTUGUESE = "pt-BR";
const CHINESE_SIMPLIFIED = "zh-Hans";
const ITALIAN_ITALY = "it-IT";
const JAPANESE_JAPAN = "ja-JP";
const INDONESIAN_INDONESIA = "id-ID";
const KOREAN_KOREA = "ko-KR";
const RUSSIAN_RUSSIA = "ru-RU";
const CZECH_CZECHIA = "cs-CZ";
const DUTCH_NETHERLANDS = "nl-NL";
const HUNGARIAN_HUNGARY = "hu-HU";
const PORTUGUESE_PORTUGAL = "pt-PT";
const POLISH_POLAND = "pl-PL";
const SWEDISH_SWEDEN = "sv-SE";
const TURKISH_TURKEY = "tr-TR";
const CHINESE_TRADITIONAL = "zh-Hant";
const DEFAULT_LANGUAGE = ENGLISH_US;
const PSEUDO_LOCALE = "pseudo";

export { BRAZILIAN_PORTUGUESE, CHINESE_SIMPLIFIED, CHINESE_TRADITIONAL, CZECH_CZECHIA, DEFAULT_LANGUAGE, DUTCH_NETHERLANDS, ENGLISH_US, FRENCH_FRANCE, GERMAN_GERMANY, HUNGARIAN_HUNGARY, INDONESIAN_INDONESIA, ITALIAN_ITALY, JAPANESE_JAPAN, KOREAN_KOREA, POLISH_POLAND, PORTUGUESE_PORTUGAL, PSEUDO_LOCALE, RUSSIAN_RUSSIA, SPANISH_SPAIN, SWEDISH_SWEDEN, TURKISH_TURKEY };
//# sourceMappingURL=constants.mjs.map
